import { useDispatch } from 'react-redux';

import { useEffect, useState } from 'react';

import { Button, Dialog, Text } from '@poliedro/tamentai';

import { resetProfile } from '../../../store/profileSlice';
import { StyledDialogRoot } from './styles';

interface AccessUnavailableDialogProps {
  open: boolean;
}

const PMAIS_URL = import.meta.env.VITE_PMAIS_URL;

const AccessUnavailableDialog = ({ open }: AccessUnavailableDialogProps) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  useEffect(() => {
    if (!isOpen) return;

    const backdrop = document.querySelector<HTMLDivElement>(
      '.t-dialog-backdrop[data-open="true"]',
    );

    const handleBackdropClick = (event: Event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    backdrop?.addEventListener('pointerdown', handleBackdropClick, true);
    backdrop?.addEventListener('click', handleBackdropClick, true);

    return () => {
      backdrop?.removeEventListener('pointerdown', handleBackdropClick, true);
      backdrop?.removeEventListener('click', handleBackdropClick, true);
    };
  }, [isOpen]);

  const handleNavigate = () => {
    localStorage.removeItem('token');
    dispatch(resetProfile());
    window.location.href = PMAIS_URL;
  };

  return (
    <StyledDialogRoot modal open={isOpen} setOpen={handleNavigate}>
      <Dialog.Header title="Atualização necessária" hideCloseButton={false} />

      <Dialog.Body>
        <Text as="p" color="#4c4c4c" variant="body-lg">
          O acesso ao Cosmos exige vínculo em uma turma com estudantes matriculados
          no período letivo atual. Procure a secretaria ou o responsável pelos
          cadastros do P+ da sua escola.
        </Text>
      </Dialog.Body>

      <Dialog.Footer>
        <Button size="sm" variant="primary" onClick={handleNavigate}>
          Voltar para o P+
        </Button>
      </Dialog.Footer>
    </StyledDialogRoot>
  );
};

export default AccessUnavailableDialog;
